import mutations from './instruments.mutations'
import actions from './instruments.actions'
import getters from './instruments.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
